import $ from "jquery"

class ImageBorder {
    constructor(){
        const self = this;
        this.init();
        $(window).resize(function ()
        {
            self.init();
        });
    }

    init() {
        const windowWidth = $(window).width(),
         imageBorderElement = $(`.clf2020-image-border img`);

        imageBorderElement.map((index, item) => {
            item.style.setProperty("--screen-width", windowWidth);
        });
    }

}

export default ImageBorder;